import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M10.5 2.188v4.807M12.303 14.482h2.604M2.688 6.996h15.625v9.615a1.2 1.2 0 0 1-1.203 1.202H3.89a1.2 1.2 0 0 1-1.203-1.202zM4.613 2.932a1.3 1.3 0 0 1 1.177-.744h9.42c.503 0 .961.29 1.177.744l1.925 4.063H2.688z"
    }, null, -1)
  ])))
}
export default { render: render }